__turbopack_context__.v({
  "content": "cwgcIa_content",
  "item": "cwgcIa_item",
  "menuIn": "cwgcIa_menuIn",
  "menuOut": "cwgcIa_menuOut",
  "separator": "cwgcIa_separator",
  "subContent": "cwgcIa_subContent",
  "subTrigger": "cwgcIa_subTrigger",
});
